export default "__VITE_ASSET__CGJASITu__"